/**
 * Auto-register all built-in locale packs.
 * Import this module once to make every supported language available.
 */
import { registerLocale } from "../i18n";

import es from "./es";
import fr from "./fr";
import de from "./de";
import it from "./it";
import pt from "./pt";
import ja from "./ja";
import zh from "./zh";
import ko from "./ko";
import ar from "./ar";
import { extraLocales } from "./extra";
import { qualityOverrides } from "./quality-overrides";

const locales: Record<string, Record<string, string>> = {
  es, fr, de, it, pt, ja, zh, ko, ar,
};

for (const [code, translations] of Object.entries(locales)) {
  registerLocale(code, {
    ...translations,
    ...(extraLocales[code] || {}),
    ...(qualityOverrides[code] || {}),
  });
}
